/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kind: NonNullable<unknown> }} Documents_Empty_KindInputs */

const cs_documents_empty_kind = /** @type {(inputs: Documents_Empty_KindInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kategorie ${i?.kind} je zatím prázdná.`)
};

const en_documents_empty_kind = /** @type {(inputs: Documents_Empty_KindInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kind} has no folders yet.`)
};

/**
* | output |
* | --- |
* | "{kind} has no folders yet." |
*
* @param {Documents_Empty_KindInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty_kind = /** @type {((inputs: Documents_Empty_KindInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Empty_KindInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_empty_kind(inputs)
	return cs_documents_empty_kind(inputs)
});